export const heartPath =
  "M12 20.5C9 18.7 4.4 15.3 2.6 11.5 1 8.1 3.1 4.4 6.8 4.4c2.2 0 3.9 1.2 5.2 3 1.3-1.8 3-3 5.2-3 3.7 0 5.8 3.7 4.2 7.1-1.8 3.8-6.4 7.2-9.4 9z";

export const sparklePath = "M12 0C13 8 16 11 24 12 16 13 13 16 12 24 11 16 8 13 0 12 8 11 11 8 12 0Z";

export const loveTones = ["#f4b6c2", "#e8a0b4", "#d98aa3", "#fdf8f4", "#f9d5dd", "#e88fa6"];

export function HeartShape({ className, style }) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true">
      <path d={heartPath} fill="currentColor" />
    </svg>
  );
}
